import checkmateApi from "../axios/checkmateApi";
import { IReport, IReportCreatePayload, IReportSection, IReportSectionCreatePayload } from "../slices/reportSlice";


export const getReportList = async (size: number, from: number) => {
    return checkmateApi({
        method: 'GET',
        url: `reports?size=${size}&from=${from}`
    });
}

export const getReportTypes = async () => {
    return checkmateApi({
        method: 'GET',
        url: `reports/types`
    });
}

export const getGraphList = async (size: number, from: number) => {
    const response = checkmateApi({
        method: 'GET',
        url: `search?size=${size}&from=${from}&expanded=false`
    });
    return response;
}

export const getReportDetails = async (reportId: string) => {
    const response = checkmateApi({
        method: 'GET',
        url: `reports/${reportId}`
    });
    return response;
}

export const createReport = async (payload: IReportCreatePayload) => {
    const response = checkmateApi({
        method: 'POST',
        url: `reports?async=true`,
        data: payload
    });
    return response;
}

export const createSection = async (payload: IReportSectionCreatePayload) => {
    const response = checkmateApi({
        method: 'POST',
        url: `reports/sections`,
        data: payload
    });
    return response;
}
export const updateReport = async (payload: IReport, generate: boolean = false) => {
    const response = checkmateApi({
        method: 'PUT',
        url: `reports?generate=${generate}`,
        data: payload
    });
    return response;
}

export const updateSection = async (payload: IReportSection, generate: boolean = false ) =>{
    const response = checkmateApi({
        method: 'PUT',
        url: `reports/sections?generate=${generate}`,
        data: payload
    });
    return response;
}

export const deleteReport = async (reportId: string) => {
    const response = checkmateApi({
        method: 'DELETE',
        url: `reports/${reportId}`,
    });
    return response;
}

export const createSummary = async (searchId: string) => {
    const response = checkmateApi({
        method: 'GET',
        url: `reports/summary/${searchId}`
    })
    return response;
}

export const removeSection = async (reportId: string, sectionId: string) => {
    const response = checkmateApi({
        method: 'DELETE',
        url: `reports/sections/${sectionId}`
    });
    return response;
}

export const getReportStatus = async (reportId: string) => {
    const response = checkmateApi({
        method: 'GET',
        url: `reports/${reportId}/status`
    });
    return response;
}